<section class="about-us " id="about-us">
    <div class="container about_us">
        <div class="row">
            <div class="col-1 col-lg-3 col-md-2 "></div>
            <div class="col-11 col-lg-9 col-md-10 ">
                <div class="header-block">
                    <h2>Переваги Anima</h2>
                    <p>
                        Відчуйте безпрецедентну турботу з Anima, основу якої складають чотири складові: наукові дослідження, передова технологія ай-трекінгу, безкомпромісні стандарти конфіденційності та об’єктивний аналіз.
                    </p>
                </div>
            </div>
        </div>

        <app-about-us-item [item]="item" *ngFor="let item of items"></app-about-us-item>

        <!--        <app-achivement></app-achivement>-->

    </div>
</section>
